<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Unavailable Items
    </Teleport>

    <template v-if="unavailableItems.length > 0">
      <p class="cf-subtitle cf-subtitle--2">
        Oops! The following {{ unavailableItems.length > 1 ? 'items are' : 'item is' }}
        unavailable and {{ unavailableItems.length > 1 ? 'have' : 'has' }}
        been removed from your cart:
      </p>

      <ul class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12 cf-bullet-list">
        <li
          v-for="item in unavailableItems"
          :key="item.orderItemId"
          class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12"
        >
          <h4 class="cf-title cf-title--4">
            {{ item.itemDescription }}
          </h4>

          <p
            v-if="item.unavailableModifiers && item.unavailableModifiers.length > 0"
            class="cf-subtitle cf-subtitle--2"
          >
            Unavailable {{ item.unavailableModifiers.length > 1 ? 'Modifiers' : 'Modifier' }}:

            <span>{{ item.unavailableModifiers.map(modifier => modifier.itemDescription).join(', ') }}</span>
          </p>
        </li>
      </ul>
    </template>

    <template v-if="invalidDaypartItems && invalidDaypartItems.length > 0">
      <p class="cf-subtitle cf-subtitle--2">
        Oops! The following
        {{ invalidDaypartItems.length > 1 ? 'items don\'t' : 'item doesn\'t' }}
        qualify for your selected order time:
      </p>

      <ul class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12 cf-bullet-list">
        <li
          v-for="item in invalidDaypartItems"
          :key="item.orderItemId"
          class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12"
        >
          <h4 class="cf-title cf-title--4">
            {{ item.itemDescription }}
          </h4>
        </li>
      </ul>
    </template>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="$closeModal('unavailableItems')"
    >
      Okay
    </button>
  </div>
</template>


<script>
  export default {
    name: 'UnavailabeItems',

    props: {
      unavailableItems: {
        type: Array,
        required: true
      },

      invalidDaypartItems: {
        type: Array,
        required: true
      }
    }
  };
</script>
